(function () {
  function parseDaysPeople(variantTitle) {
    const title = (variantTitle || "").toLowerCase();

    // days
    let days = null;
    if (title.includes("last 10")) days = 10;
    else if (title.includes("first 10")) days = 10;
    else {
      const m = title.match(/(\d+)\s*day/);
      if (m) days = parseInt(m[1], 10);
    }

    // people
    let people = null;
    const p = title.match(/(\d+)\s*(person|people)/);
    if (p) people = parseInt(p[1], 10);

    return { days, people };
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      const format =
        (window.theme && window.theme.moneyFormat) ||
        window.Shopify.money_format ||
        "{{amount}}";
      return Shopify.formatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function findVariant(variants, id) {
    return variants.find(v => String(v.id) === String(id)) || null;
  }

  function update() {
    const el = document.getElementById("per-meal-price");
    if (!el) return;

    const product = window.__IFTAR_PRODUCT__;
    if (!product || !product.variants) return;

    const idInput = document.querySelector('form[action^="/cart/add"] [name="id"]');
    if (!idInput) return;

    const variant = findVariant(product.variants, idInput.value);
    if (!variant) { el.textContent = ""; return; }

    const { days, people } = parseDaysPeople(variant.title);
    if (!days || !people) { el.textContent = ""; return; }

    const meals = days * people;
    const perMealCents = Math.round(variant.price / meals);

    el.textContent = `≈ ${formatMoney(perMealCents)} per iftar (based on ${meals} meals)`;
  }

  document.addEventListener("DOMContentLoaded", function () {
    update();
    // Dawn often changes variant without firing "change", so poll
    setInterval(update, 300);
  });
})();
